export default __webpack_public_path__ + "static/media/logo.2455a31f.svg";